export default __webpack_public_path__ + "static/media/5884-video-movie.bb98c261.gif";